import { pricingPolicyOptions } from "../utils/constants"

// Function to convert form data
export async function convertToFormData(data){
    try{
        let formData = new FormData();
        for (let key in data) {
          if (
            typeof data[key] === "object" &&
            data[key] !== null &&
            !(data[key] instanceof File)
          ) {
            // Convert object to a JSON string before appending
            formData.append(key, JSON.stringify(data[key]));
          } else {
            formData.append(key, data[key]);
          }
        }
        return formData
    }catch(error){
        console.log("Error in function convertToFormData", error.message);
        
    }
}


export  const setFavicon = async(url) => {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = url;
};

export const  calculatePrice  = (type, pricingPolicy ,basePrice, markup, quantity) =>{
  const base = parseFloat(basePrice);
  const mark = parseFloat(markup || 0);

  switch(type){
    case 'MARKUP_FEE':
      if (pricingPolicy === pricingPolicyOptions.manufacture_discount.value) {
        // Case 3: Manufacture Discount
        return 0;
      } else {
        return (base * (mark / 100)).toFixed(2);
      }
      break;
    case 'DISTRIBUTOR_PRICE_WITH_MARKUP':
      if (pricingPolicy === pricingPolicyOptions.manufacture_discount.value) {
        // Case 3: Manufacture Discount
        return (base * (1 - mark / 100)).toFixed(2);
      } else {
        // Default markup logic
        return (base * (1 + mark / 100)).toFixed(2);
      }
    break ;
    case 'MARKUP_TOTAL_PRICE':
      if (pricingPolicy === pricingPolicyOptions.manufacture_discount.value) {
        return ((base * (1 - mark / 100)) * quantity).toFixed(2);
      }else{
        return ((base * (1 + mark / 100)) * quantity).toFixed(2);
      }

      break ;

  }

}

export function calculateTotalShipment(distributorPrice, logisticsFee, customFee, logisticBufferCharge) {

    console.log("distributorPrice", distributorPrice);
    console.log("logisticsFee", logisticsFee);
    console.log("customFee", customFee);
    console.log("logisticBufferCharge", logisticBufferCharge);

    
    
  const logisticsCharge = parseFloat(distributorPrice) * (parseFloat(logisticsFee || 0) / 100);
  const customCharge = parseFloat(distributorPrice) * (parseFloat(customFee || 0) / 100);
  const bufferCharge = parseFloat(distributorPrice) * (parseFloat(logisticBufferCharge || 0) / 100);

  // parseFloat(distributorPrice) +
  let  ShipmentCharge =  parseFloat(logisticsCharge) + parseFloat(customCharge) + parseFloat(bufferCharge);
  const totalShipmentCharge = ShipmentCharge.toFixed(2)
  return totalShipmentCharge;
}


export const getDistributorOptions = (distributors, initial_gpl_price, gpl_price, logistics) => {
  if (distributors?.length > 0) {
    return distributors?.map((dist) => ({
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 8px",
          }}
        >
          <span style={{ fontWeight: "500" }}>{dist.name}</span>
          <button
            type="button"
            style={{
              padding: "4px 8px",
              border: "none",
              backgroundColor: "#007bff",
              color: "#fff",
              borderRadius: "12px",
              fontSize: "0.85em",
              cursor: "pointer",
            }}
          >
            {dist.currency} {dist.initial_price}
          </button>
        </div>
      ),
      id :  dist.id, 
      value: dist.id,
      price: dist.price,
      initial_price : dist.initial_price, 
      markup_price: dist.markup_price,
      lead_time: dist.lead_time,
      noDistributor: false,
      initial_gpl_price: initial_gpl_price,
      logistics :  logistics
    }));
  } else {
    return [
      {
        value: '',
        label: 'No Distributor',
        initial_gpl_price: initial_gpl_price,
        gpl_price: gpl_price,
        noDistributor: true,
      },
    ];
  }
};
